export const employee = (employeeObject) =>employeeObject?`${employeeObject?.surname} ${employeeObject?.name}`:""